import React, { useState } from "react";
import { DialogHeader, DialogTitle } from "../common/design-system/Dialog";
import BackIcon from "../../assets/svgIcons/back-icon.svg";

import RefreshIcon from "../../assets/svgIcons/refresh-icon.svg";
import { Button } from "../common/design-system/Button";
import type { IntegrationItemType } from "../../utils/integrationModalconstants";
import { INTEGRATIONS_LIST } from "../../utils/integrationModalconstants";

import type { ActiveStep } from "../../typing/shared";
import { useCarbon } from "../../context/CarbonContext";
import SyncedFilesList from "../CarbonFilePicker/SyncedFilesList";
import { SyncingModes } from "../CarbonFilePicker/CarbonFilePicker";
import SystemFileUpload from "./SystemFileUpload";
import type { BannerState } from "../common/Banner";
import Banner from "../common/Banner";
import { IntegrationName } from "../../typing/shared";

export default function LocalFilesScreen({
  activeStepData,
  isWhiteLabeledEntryPoint,
  onCloseModal,
  setActiveStep,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<ActiveStep>>;
  activeStepData?: IntegrationItemType;
  isWhiteLabeledEntryPoint: boolean;
  onCloseModal: () => void;
}) {
  const { entryPoint, processedIntegrations, showFilesTab } = useCarbon();

  const [bannerState, setBannerState] = useState<BannerState>({
    message: null,
  });

  const localIntegration = processedIntegrations?.find(
    (int) => int.id == IntegrationName.LOCAL_FILES,
  );
  const shouldShowFilesTab = localIntegration?.showFilesTab ?? showFilesTab;
  const [activeScreen, setActiveScreen] = useState<"FILES" | "UPLOAD">(
    shouldShowFilesTab ? "FILES" : "UPLOAD",
  );

  if (!localIntegration) return null;

  return activeScreen == "UPLOAD" ? (
    <SystemFileUpload
      activeStepData={INTEGRATIONS_LIST.find(
        (item) => item.id === IntegrationName.LOCAL_FILES,
      )}
      bannerState={bannerState}
      isWhiteLabeledEntryPoint={isWhiteLabeledEntryPoint}
      onCloseModal={onCloseModal}
      setActiveStep={setActiveStep}
      setBannerState={setBannerState}
      setScreen={setActiveScreen}
      shouldShowFilesTab={shouldShowFilesTab}
    />
  ) : (
    <>
      <DialogHeader closeButtonClass="cc-hidden sm:cc-flex">
        <div className="cc-flex-grow cc-flex cc-gap-3 cc-items-center">
          <button
            className="cc-pr-1 cc-h-10 cc-w-auto cc-shrink-0 "
            onClick={() => {
              if (
                isWhiteLabeledEntryPoint &&
                entryPoint !== "INTEGRATION_LIST"
              ) {
                onCloseModal();
              } else if (!entryPoint || entryPoint == "INTEGRATION_LIST") {
                setActiveStep("INTEGRATION_LIST");
              } else setActiveStep("CONNECT");
            }}
          >
            <img
              alt="Lock"
              className="cc-h-[18px] cc-w-[18px] dark:cc-invert-[1] dark:cc-hue-rotate-180"
              src={BackIcon}
            />
          </button>
          <div className=" dark:cc-bg-custom-gradient-dark cc-h-8 cc-w-8 sm:cc-h-14 sm:cc-w-14 cc-shrink-0 cc-bg-surface-white cc-rounded-lg cc-p-0.5 cc-shadow-e2">
            <div className="cc-h-full cc-w-full dark:cc-bg-[#0000007A] cc-bg-gray-50 cc-flex cc-items-center cc-justify-center cc-rounded-lg">
              <img
                alt={localIntegration.name}
                className="cc-h-4 cc-w-4 sm:cc-h-8 sm:cc-w-8"
                src={activeStepData?.logo}
              />
            </div>
          </div>
          <DialogTitle className="cc-flex-grow cc-text-left">
            {activeStepData?.name}
          </DialogTitle>
          <Button
            className="cc-rounded-xl cc-shrink-0 sm:cc-hidden"
            size="sm"
            variant="gray"
          >
            <img
              alt="User Plus"
              className="cc-h-[18px] cc-w-[18px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
              src={RefreshIcon}
            />
          </Button>
        </div>
      </DialogHeader>
      <Banner bannerState={bannerState} setBannerState={setBannerState} />
      <SyncedFilesList
        bannerState={bannerState}
        handleUploadFilesClick={() => setActiveScreen("UPLOAD")}
        mode={SyncingModes.UPLOAD}
        processedIntegration={localIntegration}
        selectedDataSource={null}
        setActiveStep={setActiveStep}
        setBannerState={setBannerState}
      />
    </>
  );
}
